import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, MapPin, Facebook, Youtube, Linkedin, Instagram, Lock } from "lucide-react";
import { OFFICES, COMPANY } from "../lib/site";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-ink text-bone relative z-10">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="overline text-flame mb-6">Ready when you are</p>
            <h2 className="font-display uppercase tracking-tighter leading-[0.9] text-5xl md:text-6xl">
              Let's build<br />your workforce
            </h2>
            <div className="flex flex-wrap gap-4 mt-8">
              <Link to="/apply" data-testid="footer-apply" className="inline-flex items-center gap-2 bg-flame text-white px-6 py-3 rounded-full overline hover:bg-white hover:text-ink transition-colors duration-300">
                Job Seekers <ArrowUpRight size={14} />
              </Link>
              <Link to="/employers" data-testid="footer-employers" className="inline-flex items-center gap-2 border border-bone/30 px-6 py-3 rounded-full overline hover:bg-bone hover:text-ink transition-colors duration-300">
                Employers <ArrowUpRight size={14} />
              </Link>
            </div>
            <div className="mt-8 space-y-2.5">
              <a href={COMPANY.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 text-bone/80 text-sm hover:text-flame transition-colors">
                <Phone size={15} className="text-flame" /> {COMPANY.phone}
              </a>
              <div className="flex items-start gap-3 text-bone/60 text-sm">
                <MapPin size={15} className="text-flame mt-0.5 shrink-0" /> {COMPANY.corporate}
              </div>
            </div>
            <div className="flex items-center gap-4 mt-6">
              <a href={COMPANY.socials.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="social-facebook" className="text-bone/60 hover:text-flame transition-colors"><Facebook size={18} /></a>
              <a href={COMPANY.socials.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" data-testid="social-linkedin" className="text-bone/60 hover:text-flame transition-colors"><Linkedin size={18} /></a>
              <a href={COMPANY.socials.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="social-instagram" className="text-bone/60 hover:text-flame transition-colors"><Instagram size={18} /></a>
              <a href={COMPANY.socials.youtube} target="_blank" rel="noreferrer" aria-label="YouTube" data-testid="social-youtube" className="text-bone/60 hover:text-flame transition-colors"><Youtube size={18} /></a>
            </div>
          </div>

          <div className="lg:col-span-3 lg:col-start-8">
            <p className="overline text-bone/50 mb-5">Offices</p>
            <ul className="space-y-2.5">
              {OFFICES.map((o) => (
                <li key={o.id} className="text-bone/80 text-sm flex items-center gap-2">
                  <span className="font-display uppercase tracking-tight">{o.label}</span>
                  {o.tag === "Corporate HQ" && <span className="text-flame overline">HQ</span>}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="overline text-bone/50 mb-5">Navigate</p>
            <ul className="space-y-2.5">
              {[["Home","/"],["About","/about"],["Services","/services"],["Locations","/locations"],["Apply","/apply"],["Employers","/employers"]].map(([l,to]) => (
                <li key={to}>
                  <Link to={to} data-testid={`footer-nav-${l.toLowerCase()}`} className="text-bone/80 text-sm hover:text-flame transition-colors">{l}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <p className="mt-16 pt-8 border-t border-bone/15 text-bone/35 text-xs leading-relaxed max-w-4xl">
          {COMPANY.eeo}
        </p>

        <div className="mt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 overline text-bone/40">
          <span className="flex items-center gap-3">
            <img src="/logo-mark.png" alt="HR Direct Services" className="w-8 h-8 object-contain" />
            © {new Date().getFullYear()} HR Direct Services. All rights reserved.
          </span>
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <span>HR Direct Services Inc · The GHR Company · The GHR Management Co.</span>
            <Link to="/admin" data-testid="footer-admin-login" className="inline-flex items-center gap-1.5 text-bone/40 hover:text-flame transition-colors">
              <Lock size={12} /> Staff Login
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
